import { render, staticRenderFns } from "./RecoverPassword.vue?vue&type=template&id=1d9a38c4&scoped=true&"
import script from "./RecoverPassword.vue?vue&type=script&lang=js&"
export * from "./RecoverPassword.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPassword.vue?vue&type=style&index=0&id=1d9a38c4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9a38c4",
  null
  
)

export default component.exports